// extracted by mini-css-extract-plugin
export default {"root":"uTzXe8A53gMbQjKxgJjZ","wrap":"HZG2t8gUySCPfqV1nMxo","title":"SxY2OdaaSrZlGWBIAtMQ","desc":"CS4nIoufmwUPuCTr5Je7","connect":"zqpWnaPbgIdCoV0amdJ4","p":"XOzdV1bSSxvBmO72kDR5"};